<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.modules.write"
          class="v-primary mb-1"
          @click="
            errors = [];
            $bvModal.show('create');
          "
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create module -->
        <b-modal id="create" hide-footer>
          <template v-slot:modal-title>Novo módulo</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Descrição" />
                    <input
                      type="text"
                      v-model="description"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Valor até 10 idosos" />
                    <input
                      type="text"
                      v-model="value_up_to"
                      v-on:keyup="handleValueUpTo"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Valor por idoso" />
                    <input
                      type="text"
                      v-model="value_per"
                      v-on:keyup="handleValuePer"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create módule -->
        <v-card>
          <v-card-title>
            Módulos
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="modules"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.value_up_to`]="{ item }">{{
              formatPrice(item.value_up_to)
            }}</template>
            <template v-slot:[`item.value_per`]="{ item }">{{
              formatPrice(item.value_per)
            }}</template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import routes from "../routes";
import api from "../services/api";
import { formatPrice, formatValueOnKeyUp } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Modules",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Descrição", value: "description" },
        { text: "Valor até 10 idosos", value: "value_up_to" },
        { text: "Valor por idoso", value: "value_per" },
      ],
      description: "",
      value_up_to: "",
      value_per: "",
      modules: [],
      loadingCreate: false,
      loading: true,
    };
  },
  async created() {
    this.permissions = adminData().permissions;

    await this.getModules();

    this.loading = false;
  },
  methods: {
    formatPrice,
    formatValueOnKeyUp,
    handleClickRowTable(item) {
      this.handleToDetails(item);
    },
    handleValueUpTo: function (e) {
      this.value_up_to = formatValueOnKeyUp(e.target.value);
    },
    handleValuePer: function (e) {
      this.value_per = formatValueOnKeyUp(e.target.value);
    },
    async getModules() {
      try {
        this.loading = true;

        const response = await api.get("/admin/module/paginate");

        const { modules } = response.data;

        this.modules = modules;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { description, value_up_to, value_per } = this;

        let params = {
          description,
          value_up_to,
          value_per,
        };

        const response = await api.post("/admin/module/create", params);

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.description = "";
          this.value_up_to = "";
          this.value_per = "";
          this.getModules();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToDetails: ({ id }) =>
      routes.push({ name: "module", params: { id } }),
  },
};
</script>